import { useMutation } from "@tanstack/react-query";
import { POST } from "../../../../services/index";

// ค้นหาสมาชิกในระบบ MGB ด้วยเบอร์โทร + ยอดฝาก 30 วันย้อนหลังจากวันที่เลือก
// ใช้ useMutation เพราะเป็นการกดค้นหาเอง ไม่ใช่โหลดอัตโนมัติ
//
// ⚠️ ส่ง payload ทั้งก้อนต่อไป ห้ามระบุฟิลด์ตายตัว
// (เคยพลาดมาแล้ว: hook รับแค่ { phone } ทำให้ date ที่หน้าเว็บส่งมาหายกลางทาง
//  backend เลยใช้ค่า default = วันนี้ตลอด เลือกวันที่ไปก็ไม่มีผล)
export const useLookupMgbMember = () => {
  return useMutation({
    mutationFn: async (payload) =>
      await POST("/api/v1/mgbMember/lookup", { ...payload }),
  });
};
